import React, { useEffect, useRef } from 'react';
import { Validator } from 'blaze-validator';
import { useSelector } from 'react-redux';
import Form from '../form/Form';

const getLayout = (values: any = {}, branch: any) => {
  return [
    // {
    //   type: 'section',
    //   struct: true,
    //   fields: [
    //     {
    //       name: 'number',
    //       label: 'Card Number',
    //       placeholder: '4012 8888 8888 1881',
    //       col: 8,
    //       data: values.card,
    //       type: 'creditcard',
    //     },
    //     {
    //       name: 'expiration',
    //       label: 'Expiration',
    //       col: 2,
    //       pattern: /^\d\d\/\d\d$/,
    //       data: values.expiration,
    //       placeholder: 'MM/YY',
    //     },
    //     {
    //       name: 'cvv',
    //       label: 'CVV',
    //       type: 'integer',
    //       placeholder: 'CVV',
    //       col: 2,
    //       maxlength: 4,
    //       data: values.cvv,
    //     },
    //   ],
    // },
    { name: 'firstName', label: 'First Name', required: true, col: 4, data: values.firstName },
    { name: 'lastName', label: 'Last Name', required: true, col: 4, data: values.lastName },
    { name: 'phone', label: 'Phone', required: true, col: 4, data: values.phone },
    {
      name: 'amount',
      label: 'Amount',
      type: 'currency',
      hidden: true,
      precision: 2,
      required: true,
      col: 4,
      data: values.amount,
    },
    {
      name: 'address',
      label: 'Billing Address',
      require: true,
      col: 8,
      data: values.address,
      placeholder: '',
    },
    {
      name: 'zip',
      label: 'Billing Zip',
      required: true,
      col: 4,
      data: values.zip,
    },
    {
      name: 'saveCard',
      label: 'Save Card',
      control: 'Checkbox',
      data: branch.payment.saveCard === false ? 'N' : 'Y',
    },
  ];
};

interface Props {
  onSubmit: (response: any) => void;
  values?: {
    address?: string;
    amount?: string;
    cvv?: string;
    expiration?: string;
    firstName?: string;
    lastName?: string;
    number?: string;
    phone?: string;
    zip?: string;
  };
}

interface CollectJSResponse {
  card: {
    bin: string;
    exp: string;
    hash: string;
    number: string;
    type: string; // visa etc
  };
  token: string;
  tokenType: string;
}

const NMINewCardForm = ({ values = {}, onSubmit }: Props) => {
  const formData = useRef<any>({});

  const branch = useSelector((state: any) => state.app.branch);

  const finishSubmit = (response: CollectJSResponse) => {
    const { firstName, lastName, address, zip, amount, saveCard, phone } = formData.current;
    const { token, card } = response;

    onSubmit({
      billing: {
        address,
        firstName,
        lastName,
        phone,
        zip,
      },
      amount,
      card: { ...card, last4: card.number.substring(card.number.length - 4) },
      token,
      saveCard,
    });
  };

  useEffect(() => {
    (window as any).CollectJS.configure({
      variant: 'lightbox',
      styleSniffer: true,
      callback: finishSubmit,
      fields: {
        ccnumber: {
          placeholder: '4012 8888 8888 1881',
          selector: '#CardNumber-control .input-container',
        },
        ccexp: {
          placeholder: 'MM/YY',
          selector: '#Expiration-control .input-container',
        },
        cvv: {
          placeholder: 'CVV',
          selector: '#CVV-control .input-container',
        },
      },
    });
  }, []);

  const handleSubmit = (data: any) => {
    formData.current = data;
    (window as any).CollectJS.startPaymentRequest();
  };

  return (
    <Form
      layout={getLayout(values, branch)}
      submit={handleSubmit}
      exportFormat="object"
      submitAll={true}
      trackDirty={false}
      hideCancel={true}
      submitLabel={`Pay ${Validator.sanitize('currency', values.amount, { precision: 2 })}`}
    />
  );
};

export default NMINewCardForm;
